<template>
    <div class="flex-grow-1 d-flex flex-column">
        <div class="grid-count mb-3 d-flex justify-content-between">
            <span class="align-self-end">
                {{ count }} Actions
                <span class="font-weight-bold"
                      v-if="selectedCount > 0">
                    | {{ selectedCount }} selected
                </span>
            </span>
            <div class="d-flex align-content-center">
                <reset-filters
                        @click="resetGridToDefaultOptions"></reset-filters>
                <refresh-button
                        @click="refresh"
                        :spinning="refreshing"
                >
                </refresh-button>
            </div>
        </div>
        <div class="flex-grow-1 d-flex">
            <ag-grid-vue
                    :style="'width: ' + gridWidth +'%;'"
                    class="ag-theme-balham"

                    :gridOptions="gridOptions"
                    :defaultColDef="defaultColDef"
                    :columnDefs="columnDefs"
                    :columnTypes="columnTypes"
                    :rowData="rowData"

                    @gridReady="onGridReady"
                    :floatingFilter="floatingFilter"
                    :cacheQuickFilter="cacheQuickFilter"
                    :side-bar="sideBarDef"

                    :suppressExcelExport="suppressExcelExport"
                    :suppressContextMenu="true"

                    :isExternalFilterPresent="isExternalFilterActive"
                    :doesExternalFilterPass="doesExternalFilterPass"

                    @cellClicked="onCellClicked"
                    :headerHeight="rowHeight"
                    :rowHeight="rowHeight"

                    @columnMoved="saveGridOptions"
                    @columnPinned="saveGridOptions"
                    @columnResized="saveGridOptions"
                    @columnVisible="saveGridOptions"
                    @filterChanged="saveGridOptions"
                    @sortChanged="saveGridOptions"
            >
            </ag-grid-vue>
        </div>
        <client-action-modal
            v-if="modals.action.visible"
            :show.sync="modals.action.visible"
            :client-action-id="clientActionId"
            @refresh-all="refresh"
        >
        </client-action-modal>
    </div>
</template>

<script>
import {
  clientActionGridDefaultColDef as gridDefaultColDef,
  clientActionGridColumnTypes as columnTypes,
} from '@/services/Action/ClientActionGridConfig';
import { gridColumns } from '@/services/Property/PropertyClientActionGrid';
import GridMixin from '@/components/Grid/GridMixin';
import Property from '@/services/Property/Property';
import dayjs from 'dayjs';
import ClientActionModal from '@/components/Action/Modal/ClientActionModal';
import RefreshButton from '@/components/Grid/RefreshButton';
import ResetFilters from '@/components/Grid/ResetFilters';
import AddClientActionModal from '@/components/Action/Modal/AddClientActionModal';
import debounce from "lodash/debounce";

export default {
  name: 'Property-Action-Grid',
  components: {
    AddClientActionModal,
    ClientActionModal,
    RefreshButton,
    ResetFilters,
  },
  mixins: [GridMixin],
  props: {
    property: {
      required: true,
      type: Object,
    },
    shown: {
      type: Boolean,
    },
  },
  data() {
    return {
      rowData: [],
      defaultColDef: gridDefaultColDef,
      columnDefs: null,
      columnTypes,
      clientActionId: null,
      modals: {
        action: {
          visible: false,
        },
        add: {
          visible: false,
        },
      },
      gridName: 'property-client-action-grid',
    };
  },
  created() {
    this.columnDefs = gridColumns.filter(this.filterColumn);
  },
  methods: {
    postGridReady() {
      this.setRowClasses();

      this.refresh();
    },

    /**
     * Filter columns based on permissions
     *
     * @param {Object} column
     */
    filterColumn(column) {
      return !(column.field === 'dueDate' && !this.$can(
        this.$perm.ACTIONS_VIEW_ACTION_DUE_DATE,
        this.$perm.PERMISSION_TYPE_ACTION,
      ));
    },

    async refresh() {
      this.refreshing = true;
      const { data } = await Property.getClientActions(this.property.propertyId);
      this.rowData = data.data;
      this.refreshing = false;
      await this.setGridOptions();
    },

    /**
     * Set row classes
     */
    setRowClasses() {
      const now = dayjs();
      const threeMonths = dayjs().add(3, 'month');

      this.gridOptions.getRowClass = ({ data }) => {
        if (!data) {
          return '';
        }
        return '';
      };
    },

    onCellClicked({ data }) {
      this.clientActionId = data.clientActionId;
      this.modals.action.visible = true;
    },

    doesExternalFilterPass(node) {
      return true;
    },

    isExternalFilterActive() {
      return true;
    },

    /**
     * Opens a modal by name (in data -> modals.[name])
     */
    openModal(name) {
      if (this.refreshing) {
        this.$notify({
          title: 'Please wait..',
          text: 'Actions are currently being loaded, please try again',
          type: 'warn',
        });
        return false;
      }

      this.modals[name].visible = true;
      return true;
    },
  },
  watch: {
    shown() {
      this.gridApi.sizeColumnsToFit();
    },
  },
};
</script>
